module.exports = __webpack_public_path__ + "img/同城匹配.f6625102.png";